<template>
  <div class="Typeahead">
    <SimpleTypeahead
      ref="autocomplete-input"
      autocomplete="off"
      type="text"
      data-testid="sf-typeahead"
      :items="data"
      :item-projection="filterProperty"
      :min-input-length="1"
      @onInput="handleInput"
      @selectItem="handleSelect"
    >
    </SimpleTypeahead>
  </div>
</template>

<script>
import SimpleTypeahead from 'vue3-simple-typeahead'
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css' //Optional default CSS

export default {
  components: {
    SimpleTypeahead,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    onSelect: {
      type: Function,
      required: true,
    },
    filterProperty: {
      type: Function,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    setProperty: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  methods: {
    handleInput(event) {
      this.setProperty(this.index, event.input)
    },
    handleSelect(item) {
      this.onSelect(item, this.index)
    },
  },
}
</script>
<style lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

input[type='text'].simple-typeahead-input {
  @include input-bootstrap-reset;
  @include input('simple-typeahead-input');
}
</style>
